import { LevelType } from 'data/types';
import type {
  NeighborFootprint,
  NeighborFootprints
} from 'utils/footprint-adjacent-types';
import { getEffectiveFootprintPolygons } from 'utils/footprint-polygons';
import { getEffectiveFootprintShapes } from 'utils/footprint-union';
import {
  getImmediateLevelAbove,
  getImmediateLevelBelow
} from 'utils/level-vertical-order';
import { isFoundationLevel } from 'utils/structure-basics';

function neighborFootprint(
  level: LevelType | undefined
): NeighborFootprint | null {
  const shapes = getEffectiveFootprintShapes(level);
  if (shapes.length === 0) return null;
  return { shapes, polygons: getEffectiveFootprintPolygons(level) };
}

export function getNeighborFootprints(
  structure: LevelType[],
  activeLevel: LevelType | undefined
): NeighborFootprints {
  if (!activeLevel) {
    return { below: null, above: null };
  }

  const below = neighborFootprint(
    getImmediateLevelBelow(structure, activeLevel.uniqueId)
  );

  if (!isFoundationLevel(activeLevel)) {
    return { below, above: null };
  }

  return {
    below,
    above: neighborFootprint(
      getImmediateLevelAbove(structure, activeLevel.uniqueId)
    )
  };
}
